import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { useFaireDirectFirstOrderIncentive } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectFirstOrderIncentive/useFaireDirectFirstOrderIncentive";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

interface IProps {
  align?: "left" | "center";
}

export const FaireDirectSubtitle: React.FC<IProps> = ({ align = "center" }) => {
  const { faireDirectBrand } = useFaireDirectBrand();
  const externalSalesRepName: string | undefined = getGlobalProperty(
    "externalSalesRepName"
  );

  const { formattedPercentageBasedNumber, hasDefinedPercentageBasedDiscount } =
    useFaireDirectFirstOrderIncentive();

  const salesPersonName = externalSalesRepName;
  const brandCompanyName = faireDirectBrand?.name;
  return (
    <Typography
      align={align}
      data-test-id="faire-direct-percentage-based-subtitle"
    >
      {salesPersonName && brandCompanyName ? (
        <>
          <StrictLocalMsg
            defaultMessage="{salesPersonName} invited you to shop {brandCompanyName} on Faire."
            description={{
              text: "This is on a retailer sign up modal. If the retailer is sign up through a sales rep link for the brand, they will see this sentence.",
              img: "https://cdn.faire.com/fastly/9698ae4a6057f3c44197d5453d93c7cc5397ea2b437fe828e4f7b3a19429dd9d.png",
            }}
            values={{
              salesPersonName,
              brandCompanyName,
            }}
          />
          &nbsp;
        </>
      ) : null}
      {hasDefinedPercentageBasedDiscount ? (
        <StrictLocalMsg
          defaultMessage="Get {faireDirectPercentageDiscountNumber} off and 1 year of free shipping*"
          description={{
            text: "Discount promo message. To be explicit: The user will get percentage off discount on their first order with this brand. The money is covered by Faire and not the brand. Also, the asterisk refers to a disclaimer",
            img: "https://cdn.faire.com/fastly/5600f8641ce0789e4b4a134b04e8e6a8d03ded5a2d4af8cc6151cea03e8ad02f.png",
          }}
          values={{
            faireDirectPercentageDiscountNumber: formattedPercentageBasedNumber,
          }}
        />
      ) : null}
    </Typography>
  );
};
